import * as React from "react";
import * as Glob from "../Globale";
import * as Dati from "../Dati";
import { NavLink, Redirect } from "react-router-dom";
import { BaseComponent, ChiamaAPI, BottoneAPI, Trad, Tipo, Rubrica, Indirizzi, Mandanti, CampoData } from "../components/";
import { IndiceSedeLegale } from "../components/Indirizzi";

interface IAnagraficaState {
    Dato: Dati.CRisAPIDatoTipiInfo_Anag;
    ID_Anag: number;
}

export class Anagrafica extends BaseComponent<Glob.IRouteGlobaleProps, IAnagraficaState> {
    private _CSS_PersonaFisica: string = "hidden";
    private _CSS_DittaIndividuale: string = "hidden";
    private _CSS_PersonaGiuridica: string = "hidden";

    private _modalNome: string = "";
    private _modalCognome: string = "";
    private _modalCF: string = "";

    private _Popup: boolean = false;
    private _HasTriedSave: boolean = false;

    constructor(props: any) {
        super(props);
        this.state = { Dato: new Dati.CRisAPIDatoTipiInfo_Anag(), ID_Anag: (this.props.match.params as any).ID_Anag };
        this._Popup = window.location.href.indexOf("Popup=true") > -1;
        this._HasTriedSave = false;


        this.OnRis = this.OnRis.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnTipiAnag = this.OnTipiAnag.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
    }

    static getDerivedStateFromProps(props: Glob.IRouteGlobaleProps, state: IAnagraficaState): IAnagraficaState {
        state.ID_Anag = (props.match.params as any).ID_Anag;
        return state;
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfo_Anag, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.setState({ Dato: dati, ID_Anag: dati.Dato.ID_Anag });
            let menu = 0;
            if (dati.Dato.ID_Anag > 0) {
                menu = 10;
            }
            var M = Glob.GetMenu();
            M.Main = "Home";
            M.ID_MenuMain = menu;
            this.props.SetMenu(M);
            this.OnNascondiDati(dati.Dato.ID_TipoAnagPrincipale);
        } else {
            this.OnNascondiDati(this.state.Dato.Dato.ID_TipoAnagPrincipale);
        }

        return false;
    }

    private OnTipiAnag(sender: ChiamaAPI, dati: Dati.CRisAPIListaTipo, datiNuovi: boolean): React.ReactNode {
        let R: any[] = [];
        if (dati != undefined) {
            for (let T in dati.Dati) {
                let Sel: boolean = false;
                for (let D in this.state.Dato.Tipi["TipiAnag"]) {
                    if (this.state.Dato.Tipi["TipiAnag"][D].ID_Chiave == dati.Dati[T].ID_Chiave) {
                        Sel = this.state.Dato.Tipi["TipiAnag"][D].Selezionato;
                    }
                }
                R.push(
                    <div key={dati.Dati[T].ID_Chiave} className="divtabella">
                        <label htmlFor={"Tipi[TipiAnag][" + dati.Dati[T].ID_Chiave + "].Selezionato"} className="kt-checkbox kt-checkbox--solid kt-checkbox--brand">
                            {Trad.Trad(dati.Dati[T].Valore)}
                            <input
                                onChange={e => {
                                    this.OnChange(e);
                                }}
                                type="checkbox"
                                checked={Sel}
                                name={"Tipi[TipiAnag][" + dati.Dati[T].ID_Chiave + "].Selezionato"}
                                value={"Tipi[TipiAnag][" + dati.Dati[T].ID_Chiave + "].Selezionato"}
                                id={"Tipi[TipiAnag][" + dati.Dati[T].ID_Chiave + "].Selezionato"}
                            />
                            <span></span>
                        </label>
                    </div>
                );
            }
        }
        return R;
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            let TestoErrore = Trad.Trad(dati.ErrTesto);
            if (dati.ErrTesti.length > 0) {
                switch (dati.ErrTesti[0]) {
                    case "ErroreSanzioni":
                        TestoErrore = Trad.TradParam("ErroreSanzioni:{1-S}", [dati.ErrTesti[1]]);
                        break;
                }
            }
            Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), TestoErrore);
            this._HasTriedSave = true;

        } else {
            this.OnChange("Dato.ID_Anag", dati.ID_Chiave);
            this.props.history.replace("/anagrafica/" + dati.ID_Chiave + (this._Popup ? "?Popup=true" : ""));
            this.state.Dato.Dato.ID_TipoAnagStato = dati.MessaggioDati;
            this.setState({ Dato: this.state.Dato });
            Glob.InfoModaleSuccess(Trad.Trad("ANAGRAFICA"), Trad.TradParam("Anagrafica salvata correttamente con ID: {1-S}", [dati.ID_Chiave]));
            if (this._Popup) {
                let PopupID_Anag = document.getElementById("PopupID_Anag") as HTMLInputElement | null;
                if (PopupID_Anag != null) {
                    PopupID_Anag.value = dati.ID_Chiave.toString();
                }
                window.close();
            }
        }
    }

    private OnClickSalvaRappresentante(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), Trad.Trad(dati.ErrTesto));
        } else {
            this.OnChange("Dato.Dato.ID_AnagLegaleRappresentante", dati.ID_Chiave);
            Glob.InfoModaleSuccess(Trad.Trad("ANAGRAFICA"), Trad.Trad("Anagrafica salvata correttamente con ID: " + dati.ID_Chiave));
            this.forceUpdate();
        }
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        var Ingr = new Dati.CIngrAPITipi<Dati.CDatiAnag>();
        Ingr.Dato = this.state.Dato.Dato;
        Ingr.Tipi = this.state.Dato.Tipi;

        if (Ingr.Dato.CodiceFiscale == undefined) Ingr.Dato.CodiceFiscale = "";
        if (Ingr.Dato.PartitaIVA == undefined) Ingr.Dato.PartitaIVA = "";

        return Ingr;
    }

    private OnInvioSalvaRappresentante(sender: BottoneAPI): any {
        var Ingr = new Dati.CIngrAPITipi<Dati.CDatiAnag>();
        Ingr.Dato.Nome = this._modalNome;
        Ingr.Dato.Cognome = this._modalCognome;
        Ingr.Dato.RagioneSociale = "";
        Ingr.Dato.PartitaIVA = "";
        Ingr.Dato.CodiceFiscale = this._modalCF;
        Ingr.Dato.DataNascita = new Date("1901-01-01");
        Ingr.Dato.LuogoNascita = "";
        Ingr.Dato.Sesso = "";
        Ingr.Dato.RecapitiJSON = "";
        Ingr.Dato.IndirizziJSON = "";
        Ingr.Dato.MandantiJSON = "";
        Ingr.Dato.ID_TipoAnagPrincipale = Glob.Tipi_TAP_PersonaFisica;
        Ingr.Dato.ID_TipoAnagStato = Glob.Tipi_AS_InAcquisizione;
        //Ingr.Tipi = this.state.Dato.Tipi;
        return Ingr;
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
        Glob.InfoModaleError(Trad.Trad("ANAGRAFICA ERRORE"), errore.message);
    }

    private OnNascondiDati(valore: string) {
        switch (valore) {
            case Glob.Tipi_TAP_PersonaFisica:
                this._CSS_PersonaFisica = "";
                this._CSS_PersonaGiuridica = "hidden";
                this._CSS_DittaIndividuale = "hidden";
                break;
            case Glob.Tipi_TAP_PersonaGiuridica:
            case Glob.Tipi_TAP_ATI:
                this._CSS_PersonaFisica = "hidden";
                this._CSS_PersonaGiuridica = "";
                this._CSS_DittaIndividuale = "";
                break;
            case Glob.Tipi_TAP_Beneficiario:
                this._CSS_PersonaFisica = "hidden";
                this._CSS_PersonaGiuridica = "";
                this._CSS_DittaIndividuale = "";
                break;
            default:
                this._CSS_PersonaFisica = "hidden";
                this._CSS_PersonaGiuridica = "hidden";
                this._CSS_DittaIndividuale = "hidden";
                break;
        }
    }

    private OnChangeDetailsType = (valore: string) => {
        const addresses = this.state.Dato.Dato.IndirizziJSON && JSON.parse(this.state.Dato.Dato.IndirizziJSON);
        const isMainAddressRequired = valore == Glob.Tipi_TAP_PersonaGiuridica || valore == Glob.Tipi_TAP_PersonaFisica || valore == Glob.Tipi_TAP_DittaIndividuale;

        if (addresses && isMainAddressRequired) {
            addresses[0].Tipo = [IndiceSedeLegale];
            this.OnChange("Dato.IndirizziJSON", JSON.stringify(addresses));
        }
    };

    private OnChangeAddresses = (e: string, val: string) => {
        const addresses = val ? JSON.parse(val) : [];
        const mainAddress = addresses[0] || {};

        this.OnChange("Dato.Indirizzo", mainAddress.Indirizzo || "");
        this.OnChange(e, val);
    };

    private OnCambiaLegaleRappresentante(campo: string, valore: string) {
        switch (campo) {
            case "modalNome":
                this._modalNome = valore;
                break;
            case "modalCognome":
                this._modalCognome = valore;
                break;
            case "modalCodiceFiscale":
                this._modalCF = valore;
                break;
        }
        this.forceUpdate();
    }

    private ApriPopupLegaleRappresentante(): void {
        let PopupLegaleRappresentante: Window | null = window.open("/anagrafica/0?Popup=true", "PopupLegaleRappresentante", "width=1920,height=1080");
        let self = this;
        if (PopupLegaleRappresentante != null) {
            PopupLegaleRappresentante.onbeforeunload = function () {
                if (PopupLegaleRappresentante != null) {
                    let PopupID_Anag = PopupLegaleRappresentante.document.getElementById("PopupID_Anag") as HTMLInputElement | null;
                    if (PopupID_Anag != null && PopupID_Anag.value != null) {
                        self.state.Dato.Dato.ID_AnagLegaleRappresentante = Number(PopupID_Anag.value);
                        self.setState({ Dato: self.state.Dato });
                    }
                }
            };
        }
    }

    public render() {
        if (!this.ControlloAutorizzazione("AnagController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        var caricaDocumenti = <div></div>;
        if (this.state.ID_Anag > 0) {
            caricaDocumenti = (
                <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                    <a href={"/file/" + this.state.Dato.Dato.ID_Anag} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black" title={Trad.Trad("Documenti")}>
                        <i className="fa fa-archive"></i>
                    </a>
                </div>
            );
        }

        const addresses = this.state.Dato.Dato.IndirizziJSON && JSON.parse(this.state.Dato.Dato.IndirizziJSON);
        const isFormValid = !!(addresses?.length && addresses[0].Indirizzo && addresses[0].Citta && addresses[0].Cap && addresses[0].Provincia && addresses[0].Nazione);

        return (
            <div className="kt-portlet">
                <input type="hidden" id="PopupID_Anag" value={this.state.ID_Anag} />
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon ">
                                <i className="fa fa-users"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">{Trad.Trad("Anagrafica")}</h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            {caricaDocumenti}
                            <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                                <NavLink
                                    to="/anagrafica/0"
                                    className={"kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black" + this._VisibileScrittura}
                                    title={Trad.Trad("Nuovo")}
                                >
                                    <i className="fa fa-plus"></i>
                                </NavLink>
                            </div>
                        </ul>
                    </div>
                </div>
                <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row dashed-border-bottom">
                            <div className="col-lg-4">
                                <label>ID</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input
                                        type="text"
                                        className="form-control kt-input"
                                        value={this.state.ID_Anag || ""}
                                        name="Dato.ID_Anag"
                                        onChange={e => {
                                            this.OnChange(e);
                                        }}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">{Trad.Trad("Stato")}</label>
                                <Tipo
                                    Campo="Dato.ID_TipoAnagStato"
                                    ID_ChiaveString={this.state.Dato.Dato.ID_TipoAnagStato ?? Glob.Tipi_AS_InAcquisizione}
                                    OnAggiorna={this.OnChange}
                                    Dati={this.state.Dato.Tipi["TipiAnagStati"]}
                                />
                            </div>
                            <div className="col-lg-4">
                                <label className="">{Trad.Trad("Tipo Anagrafica")}</label>
                                <Tipo
                                    Campo="Dato.ID_TipoAnagPrincipale"
                                    ID_ChiaveString={this.state.Dato.Dato.ID_TipoAnagPrincipale}
                                    OnAggiorna={(c, v) => {
                                        this.OnNascondiDati(v);
                                        this.OnChangeDetailsType(v);
                                        this.OnChange(c, v);
                                    }}
                                    Dati={this.state.Dato.Tipi["TipiAnagPrincipale"]}
                                />
                            </div>
                        </div>
                        <div className={"form-group kt-form login-form__group row " + this._CSS_PersonaGiuridica}>
                            <div className="col-lg-6">
                                <label>{Trad.Trad("Ragione Sociale")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={this.state.Dato.Dato.RagioneSociale || ""}
                                        id="RagioneSociale"
                                        name="Dato.RagioneSociale"
                                        onChange={e => {
                                            this.OnChange(e);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <label>{Trad.Trad("Tipo Società")}</label>
                                <Tipo
                                    URL="/api/Tipi/Tipo?tabella=TipiSocieta&campo=TipoSocieta"
                                    Campo="Dato.ID_TipoSocieta"
                                    ID_Chiave={this.state.Dato.Dato.ID_TipoSocieta || 0}
                                    OnAggiorna={this.OnChange}
                                />
                            </div>
                            {Glob.AzioneAbilitata("CapogruppoAnag", Glob.Lettura) && (
                                <div className="col-lg-3">
                                    <label>{Trad.Trad("Capogruppo")}</label>
                                    <Tipo
                                        URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                        Campo="Dato.ID_AnagCapoGruppo"
                                        ID_Chiave={this.state.Dato.Dato.ID_AnagCapoGruppo}
                                        OnAggiorna={this.OnChange}
                                        TradValori
                                        LinkSelezione="/anagrafica/"
                                    />
                                </div>
                            )}
                        </div>
                        <div className={"form-group kt-form login-form__group row " + this._CSS_PersonaFisica}>
                            <div className={"col-lg-4 " + this._CSS_PersonaFisica}>
                                <label>{Trad.Trad("Nome")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={this.state.Dato.Dato.Nome || ""}
                                        id="Nome"
                                        name="Dato.Nome"
                                        onChange={e => {
                                            e.currentTarget.value = Glob.CapitalizeFirstLetter(e.currentTarget.value);
                                            this.OnChange(e);
                                        }}

                                    />
                                </div>
                            </div>
                            <div className={"col-lg-4 " + this._CSS_PersonaFisica}>
                                <label>{Trad.Trad("Cognome")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={this.state.Dato.Dato.Cognome || ""}
                                        id="Cognome"
                                        name="Dato.Cognome"
                                        onChange={e => {
                                            e.currentTarget.value = Glob.CapitalizeFirstLetter(e.currentTarget.value);
                                            this.OnChange(e);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={"col-lg-4" + this._CSS_PersonaFisica}>
                                <label>{Trad.Trad("CF")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={this.state.Dato.Dato.CodiceFiscale || ""}
                                        id="CodiceFiscale"
                                        name="Dato.CodiceFiscale"
                                        onChange={e => {
                                            e.currentTarget.value = e.currentTarget.value.toUpperCase();
                                            this.OnChange(e);
                                        }}
                                        pattern={Glob.REGEXPerControlloPIVA(this.state.Dato.Dato.ID_TipoAnagPrincipale, (this.state.Dato.Dato.CodiceFiscale || "").length)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={"form-group kt-form login-form__group row " + this._CSS_PersonaFisica}>
                            <div className="col-lg-4">
                                <label className="">{Trad.Trad("Data nascita")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <div className="form-control">
                                        <CampoData
                                            ValoreInArrivo={this.state.ID_Anag > 0}
                                            Name="Dato.DataNascita"
                                            Id="Dato.DataNascita"
                                            Valore={this.state.Dato.Dato.DataNascita}
                                            OnChange={this.OnChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label>{Trad.Trad("Luogo nascita")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input
                                        type="text"
                                        id="Dato.LuogoNascita"
                                        className="form-control"
                                        placeholder={Trad.Trad("Luogo nascita")}
                                        value={this.state.Dato.Dato.LuogoNascita || ""}
                                        name="Dato.LuogoNascita"
                                        onChange={e => {
                                            e.currentTarget.value = Glob.CapitalizeFirstLetter(e.currentTarget.value);
                                            this.OnChange(e);
                                        }}
                                    />
                                    <span className="kt-input-icon__icon kt-input-icon__icon--right">
                                        <span>
                                            <i className="la la-map-marker"></i>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label>{Trad.Trad("Sesso")}</label>
                                <div className="kt-radio-list">
                                    <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                        <input
                                            name="Dato.Sesso"
                                            value="F"
                                            type="radio"
                                            checked={this.state.Dato.Dato.Sesso == "F"}
                                            onChange={e => {
                                                this.OnChange(e);
                                            }}
                                        />
                                        {Trad.Trad("Femmina")}
                                        <span></span>
                                    </label>
                                    <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                        <input
                                            name="Dato.Sesso"
                                            value="M"
                                            type="radio"
                                            checked={this.state.Dato.Dato.Sesso == "M"}
                                            onChange={e => {
                                                this.OnChange(e);
                                            }}
                                        />
                                        {Trad.Trad("Maschio")}
                                        <span></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className={"form-group kt-form login-form__group row " + this._CSS_PersonaGiuridica}>
                            <div className="col-lg-3">
                                <label>{Trad.Trad("PIVA")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={this.state.Dato.Dato.PartitaIVA || ""}
                                        id="PartitaIVA"
                                        name="Dato.PartitaIVA"
                                        onChange={e => {
                                            this.OnChange(e);
                                        }}
                                        pattern={Glob.REGEX_PIVA}
                                    />
                                </div>
                            </div>
                            <div className={"col-lg-3 " + this._CSS_DittaIndividuale}>
                                <label>{Trad.Trad("CF")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={this.state.Dato.Dato.CodiceFiscale || ""}
                                        id="CodiceFiscale"
                                        name="Dato.CodiceFiscale"
                                        onChange={e => {
                                            e.currentTarget.value = e.currentTarget.value.toUpperCase();
                                            this.OnChange(e);
                                        }}
                                        pattern={Glob.REGEXPerControlloPIVA(this.state.Dato.Dato.ID_TipoAnagPrincipale, (this.state.Dato.Dato.CodiceFiscale || "").length)}
                                    />
                                </div>
                            </div>
                            <div className={"col-lg-6 " + this._CSS_DittaIndividuale}>
                                <label>{Trad.Trad("Legale Rappresentante")}</label>{" "}
                                <a
                                    href="/anagrafica/0"
                                    onClick={e => {
                                        e.preventDefault();
                                        this.ApriPopupLegaleRappresentante();
                                    }}
                                    className="arrow"
                                >
                                    {" "}
                                    <i className="fa fa-plus" />{" "}
                                </a>
                                <Tipo
                                    URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                    Campo="Dato.ID_AnagLegaleRappresentante"
                                    ID_Chiave={this.state.Dato.Dato.ID_AnagLegaleRappresentante}
                                    OnAggiorna={this.OnChange}
                                    TradValori
                                    LinkSelezione="/anagrafica/"
                                />
                            </div>
                            <div className="modal fade" id="modaleInsAnagrafica" role="dialog" aria-labelledby="modaleInsAnagrafica" style={{ display: "none" }} aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header alert-info">
                                            <h5 className="modal-title" id="modaleAnagTitolo">
                                                {Trad.Trad("Inserimento Legale Rappresentante")}
                                            </h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body" id="modaleAnagTesto">
                                            <div className="form-group kt-form login-form__group row">
                                                <div className="col-lg-6">
                                                    <label>{Trad.Trad("Nome")}</label>
                                                    <div className="kt-input-icon kt-input-icon--right">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={this._modalNome}
                                                            id="modalNome"
                                                            name="modalNome"
                                                            onChange={e => this.OnCambiaLegaleRappresentante("modalNome", Glob.CapitalizeFirstLetter(e.currentTarget.value))}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label>{Trad.Trad("Cognome")}</label>
                                                    <div className="kt-input-icon kt-input-icon--right">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={this._modalCognome}
                                                            id="modalCognome"
                                                            name="modalCognome"
                                                            onChange={e => this.OnCambiaLegaleRappresentante("modalCognome", Glob.CapitalizeFirstLetter(e.currentTarget.value))}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group kt-form login-form__group row">
                                                <div className="col-lg-12">
                                                    <label>{Trad.Trad("CF")}</label>
                                                    <div className="kt-input-icon kt-input-icon--right">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={this._modalCF}
                                                            id="modalCodiceFiscale"
                                                            name="modalCodiceFiscale"
                                                            onChange={e => this.OnCambiaLegaleRappresentante("modalCodiceFiscale", e.currentTarget.value.toUpperCase())}
                                                            pattern={Glob.REGEX_CF}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <BottoneAPI
                                                Default={false}
                                                Testo={Trad.Trad("Inserisci")}
                                                URL={`/api/anag/SalvaAnagraficaAsync`}
                                                Metodo="POST"
                                                OnInvio={s => this.OnInvioSalvaRappresentante(s)}
                                                OnClick={(s, d) => this.OnClickSalvaRappresentante(s, d)}
                                                OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                                DataDismiss="modal"
                                            />
                                            <button type="button" className="btn btn-secondary" data-dismiss="modal" id="btnModaleInsAnagraficaChiudi">
                                                {Trad.Trad("Chiudi")}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <Indirizzi
                                Id="Dato.IndirizziJSON"
                                Name="Dato.IndirizziJSON"
                                Value={this.state.Dato.Dato.IndirizziJSON}
                                OnChange={this.OnChangeAddresses}
                                ID_TipoAnagPrincipale={this.state.Dato.Dato.ID_TipoAnagPrincipale}
                            />
                            <Rubrica Id="Dato.RecapitiJSON" Name="Dato.RecapitiJSON" Value={this.state.Dato.Dato.RecapitiJSON} OnChange={this.OnChange} />
                            {this.MandantiVisibile() && <Mandanti Id="Dato.MandantiJSON" Name="Dato.MandantiJSON" Value={this.state.Dato.Dato.MandantiJSON} OnChange={this.OnChange} />}
                        </div>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--right">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--right">
                                    <ChiamaAPI Aggiornare={1} URL={"/api/anag/seleziona?id_Anag=" + this.state.ID_Anag} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
                                    <BottoneAPI
                                        Default={false}
                                        Testo={Trad.Trad("Salva")}
                                        URL={`/api/anag/SalvaAnagraficaAsync?sbloccata=${this._HasTriedSave}`}
                                        Metodo="POST"
                                        OnInvio={s => this.OnInvioSalva(s)}
                                        OnClick={(s, d) => this.OnClickSalva(s, d)}
                                        OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                        Attivo={isFormValid}
                                        Visibile={this._Scrittura}
                                    />
                                    <button type="button" className={`btn btn-secondary kt-margin-l-5 ${this._VisibileScrittura}`} onClick={history.back}>
                                        {Trad.Trad("Annulla")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    private MandantiVisibile() {
        if (this.state.Dato.Dato.ID_TipoAnagPrincipale == Glob.Tipi_TAP_ATI) return true;

        if ((this.state.Dato.Dato.MandantiJSON || "") == "") return false;

        return this.state.Dato.Dato.MandantiJSON != "[]";
    }
}



// WEBPACK FOOTER //
// ./src/form/Anagrafica.tsx